import React, { useState } from 'react';
import { MDBCollapse, MDBBtn } from 'mdb-react-ui-kit';
import { useParams } from 'react-router-dom';

import CargueIndicadores from './CarguesMasivos/CargueIndicadores';
import CargueCalificaciones from './CarguesMasivos/CargueCalificaciones';
import CargueVisita from './CarguesMasivos/CargueVisita';

export default function App() {
  let { id } = useParams();
  console.log(id);
  const [showShow, setShowShow] = useState(false);
  const [showShow1, setShowShow1] = useState(false);
  const [showShow2, setShowShow2] = useState(false);
 

  const toggleShow = () => setShowShow(!showShow);
  const toggleShow1 = () => setShowShow1(!showShow1);
  const toggleShow2 = () => setShowShow2(!showShow2);
  


  return (
    <>
      <div className="test">
        <div>
          <div className="container">
            <div className="text-center">
              <div class="container-fluid">
                <div class="card shadow mb-4">
                  <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">Proceso De Cargue Masivo</h6>
                  </div>
                  <div class="card-body">
                    <div class="table-responsive"></div>

                    <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">



                      <tr> <MDBBtn outline className="btn btn-light btn-user btn-block" onClick={toggleShow}>
                     1. Cargue masivo de indicadores
                      </MDBBtn>
                        <MDBCollapse show={showShow}>
                          <CargueIndicadores idSolicitud={id} />
                        </MDBCollapse>
                      </tr>
                      <hr className="sidebar-divider" />  
                      <tr>
                        <MDBBtn outline className='btn btn-light btn-user btn-block' color='primary' onClick={toggleShow1}>
                        2. Cargue masivo de Calificaciones
                        </MDBBtn>
                        <MDBCollapse show={showShow1}>
                          <CargueCalificaciones idSolicitud={id}/>
                        </MDBCollapse>
                      </tr>
                      <hr className="sidebar-divider" />  
                      <tr>
                        <MDBBtn outline className="btn btn-light btn-user btn-block" onClick={toggleShow2}>
                        3. Cargue de Información solicitada durante la visita de evaluación
                        </MDBBtn>

                        <MDBCollapse show={showShow2}>
                          <CargueVisita idSolicitud={id}/>
                        </MDBCollapse>
                      </tr>
                     
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}